class ParallaxEffect {
  constructor() {
    this.devided = 5;
    this.target = '.js-parallax';
    this.fv = '.js-fv';
    this.addEvents();
  }

  getScrollTop() {
    return Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop,
      window.scrollY
    );
  }

  setPosition() {
    document.querySelectorAll(this.target).forEach(element => {
      const position = element.getBoundingClientRect().top;
      const translateY = position / this.devided / 2 * -1;
      // console.log(position)
      if ( position < window.innerHeight && position > window.innerHeight*-1 ) {
        element.style.opacity = 1;
        element.firstElementChild.style.transform = 'translateY(' + translateY + 'px)';
      }
    });
  }

  setFvPosition() {
    const scrollTop = this.getScrollTop();
    const position1 = scrollTop / this.devided;
    const position2 = scrollTop / this.devided / 3;
    if ( scrollTop < window.innerHeight ) {
      document.querySelectorAll('.js-fvBg').forEach(element => {
        element.style.transform = 'translateY(' + position1 + 'px)';
      });
      document.querySelectorAll('.js-fvImage').forEach(element => {
        element.style.transform = 'translateY(-' + position2 + 'px)';
      });
    }
  }

  addEvents() {
    if ( window.innerWidth > 640 && document.querySelectorAll(this.target).length > 0 ) {
      document.addEventListener('scroll', e => {
        this.setPosition();
      });
    }

    if ( document.querySelectorAll(this.fv).length > 0 ) {
      document.addEventListener('scroll', e => {
        this.setFvPosition();
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', event => {
  new ParallaxEffect();
});
